import { PrimaryIcon } from '../../../../icons/PrimaryIcon/PrimaryIcon';
import { useMarket } from '../../../../providers/MarketProvider';
import { StyledLocalizedLink } from './Logo.styles';

export const Logo = () => {
  const market = useMarket();

  return (
    <StyledLocalizedLink href="/">
      <PrimaryIcon market={market.countryISO === 'DK' ? 'DTF' : 'Sembo'} />
    </StyledLocalizedLink>
  );
};
